import { useEffect, useState } from "react";

import toast from "react-hot-toast";

import { getTenant } from "../../../utils/tenantManager";

import {
  getScalesApi,
  getScaleByIdApi,
  createScaleApi,
  getUnitsApi,
  deleteScaleApi,
  updateScaleApi
} from "../../../services/operation/scale/scaleService";

export const useScaleViewModel = () => {
  const tenantId = getTenant();

  const [scale, setScale] = useState<any>(null);

  const [units, setUnits] = useState<any[]>([]);

  useEffect(() => {
    loadUnits();
  }, []);

  const [scales, setScales] = useState<any[]>([]);

  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);

  const [totalCount, setTotalCount] = useState(0);

  const [search, setSearch] = useState("");

  const [hasMore, setHasMore] = useState(true);

  const updateScale = async (data: any) => {
    try {
      const res = await updateScaleApi(data, tenantId!);

      toast.success("Scale updated successfully");

      return res;
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to update scale");

      throw err;
    }
  };

  // ================= LOAD =================
  const loadScales = async (
    customPage?: number,
    customSearch?: string,
    append = false,
  ) => {
    try {
      setLoading(true);

      const currentPage = customPage || page;

      const currentSearch = customSearch ?? search;

      const res = await getScalesApi(currentPage, 10, currentSearch, tenantId!);

      const list = res?.data?.data || [];

      if (append) {
        setScales((prev) => [...prev, ...list]);
      } else {
        setScales(list);
      }

      setTotalCount(res?.data?.totalCount || 0);

      setHasMore(list.length === 10);
    } catch {
      toast.error("Failed to load scales");
    } finally {
      setLoading(false);
    }
  };

  const loadUnits = async () => {
    try {
      const res = await getUnitsApi(tenantId!);

      setUnits(res?.data || []);
    } catch {
      toast.error("Failed to load units");
    }
  };

  const getScaleById = async (id: string) => {
    try {
      const res = await getScaleByIdApi(id, tenantId!);

      setScale(res.data);

      return res.data;
    } catch {
      toast.error("Failed to load scale");
    }
  };

  const createScale = async (data: any) => {
    try {
      const res = await createScaleApi(data, tenantId!);

      toast.success("Scale created");

      await loadScales();

      return res;
    } catch (err: any) {
      console.log("FULL ERROR", err?.response?.data);

      console.log("VALIDATION ERRORS", err?.response?.data?.errors);

      toast.error(err?.response?.data?.title || "Failed to create scale");

      throw err;
    }
  };

  const deleteScale = async (id: string) => {
    try {
      await deleteScaleApi(id, tenantId!);

      toast.success("Scale deleted successfully");

      await loadScales();
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to delete scale");
    }
  };

  // ================= DEFAULT LOAD =================
  useEffect(() => {
    loadScales();
  }, [page, search]);

  return {
    scales,
    scale,

    units,

    loading,

    page,
    setPage,

    totalCount,

    search,
    setSearch,

    hasMore,

    loadScales,

    loadUnits,

    getScaleById,

    createScale,

    deleteScale,

    updateScale,
  };
};
